export default "<input type='text' id=\"abc\" value='hello'>\n"